import { render, staticRenderFns } from "./ModalSignup.vue?vue&type=template&id=296421de&lang=pug"
import script from "./ModalSignup.vue?vue&type=script&lang=js"
export * from "./ModalSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports